import i18n from 'l10n';
import Handlebars from 'handlebars';

const it = {};
const handler = function (selector, json) {
    const {
        creditsAvailable,
        creditsReserved,
        creditsSpent,
        subscriptionLevel,
        emailReserved,
        postpaid
    } = json;

    const $element = $(selector);
    if (subscriptionLevel === 1) {
        $("#emails-reserved-title").text(i18n.t("dashboard.reservedEmailsTitle", {count: emailReserved}));
        $("#emails-reserved-text").text(emailReserved);
        $("#reservedEmailsDiv").show();
    }
    const $creditsAndAnalysis = $("#creditsAndAnalysis");
    const $creditsInfo = $("#creditsInfo");
    const $reportCreditsTile = $("#reportCreditsTile");
    const $reportCreditsTileLastWeek = $("#reportCreditsTileLastWeek");

    if (postpaid) {
        const creditTiles = $creditsAndAnalysis.find(".credits-tile");
        $(creditTiles).remove();                      //Dashboard.htm
        $creditsInfo.remove();                        //Analytics.htm
        $reportCreditsTile.remove();                  //Analytics.htm
        $reportCreditsTileLastWeek.remove();          //Analytics.htm
        return;
    }
    $creditsAndAnalysis.find(".credits-tile").show();  //Dashboard.htm
    $creditsInfo.show();                               //Analytics.htm
    $reportCreditsTile.show();                         //Analytics.htm

    $reportCreditsTileLastWeek.show();                 //Analytics.htm

    const $crSum = $element.find("#credit-sum-1");
    const $crReserved = $element.find("#credit-reserved-1");
    const credAvailableString = creditsAvailable.toFixed(2);
    $crSum.show().text(credAvailableString);
    const fSize1 = Handlebars.helpers.dynamicFontSize(credAvailableString, $crSum.data("font-length"));
    $crSum.addClass(fSize1.toString());
    $element.find("#credit-text").text(i18n.t("dashboard.credits", {count: creditsAvailable}));
    $element.find("#credit-sum-title").text(i18n.t("dashboard.creditTile", {count: creditsAvailable}));
    $element.find("#credit-reserved-title").text(i18n.t("dashboard.reservedTile", {count: creditsReserved}));
    const fSize2 = Handlebars.helpers.dynamicFontSize(creditsReserved.toFixed(1),
        $crReserved.data("font-length"));
    $crReserved.addClass(fSize2.toString());
    $crReserved.text(creditsReserved.toFixed(2));
    $element.find("#credits-spent").text(creditsSpent.toFixed(1));
    const $crDepleted = $element.find('#warning-credits-depleted');
    const $crLow = $element.find('#warning-credits-low');
    const $goAhead = $element.find('#go-ahead');
    if (creditsAvailable < 150 && creditsAvailable !== 0) {
        $goAhead.hide();
        $crDepleted.hide();
        $crLow.show();
    } else if (creditsAvailable === 0) {
        $crLow.hide();
        $goAhead.hide();
        $crDepleted.show();
    } else {
        $crLow.hide();
        $crDepleted.hide();
        $goAhead.show();
    }
};
it.init = function (selector) {
    /* TODO Replace with model fetch */
    $.getDefaultJSONQ('/CampaignCloud/UserInfo', null, handler.bind(this, selector));
};
export default it;
